export const NEARBY_MAP_ZOOM = 14;
export const CITY_MAP_ZOOM = 11;

/** Пины дальше ~90 км от медианы не участвуют в камере (битые координаты). */
const OUTLIER_DEG = 0.8;

export type MapLatLng = { lat: number; lng: number };
export type MapCamera = { center: [number, number]; zoom: number };

/** Яндекс.Карты: [долгота, широта]. */
export function nearbyMapLocation(user: MapLatLng): MapCamera {
    return {
        center: [user.lng, user.lat],
        zoom: NEARBY_MAP_ZOOM,
    };
}

export function cityMapLocation(city: MapLatLng): MapCamera {
    return {
        center: [city.lng, city.lat],
        zoom: CITY_MAP_ZOOM,
    };
}

/** Одна и та же камера — не дергать setLocation повторно. */
export function isSameMapCamera(a: MapCamera | null | undefined, b: MapCamera | null | undefined): boolean {
    if (!a || !b) {
        return a === b;
    }

    return a.center[0] === b.center[0]
        && a.center[1] === b.center[1]
        && a.zoom === b.zoom;
}

export function listingMapLocation(
    coordinates: Array<[number, number]>,
    city?: MapLatLng | null,
): MapCamera | null {
    if (city && Number.isFinite(city.lat) && Number.isFinite(city.lng)) {
        return cityMapLocation(city);
    }

    const inliers = coordinatesInCityCluster(coordinates);
    if (inliers.length === 0) {
        return null;
    }

    if (inliers.length === 1) {
        return {center: inliers[0], zoom: 15};
    }

    return {center: medianCenter(inliers), zoom: CITY_MAP_ZOOM};
}

function coordinatesInCityCluster(coords: Array<[number, number]>): Array<[number, number]> {
    const valid = coords.filter(([lng, lat]) =>
        Number.isFinite(lng) && Number.isFinite(lat) && lng !== 0 && lat !== 0,
    );
    if (valid.length < 2) {
        return valid;
    }

    const [medianLng, medianLat] = medianCenter(valid);
    const near = valid.filter(([lng, lat]) =>
        Math.hypot(lng - medianLng, lat - medianLat) <= OUTLIER_DEG,
    );

    return near.length > 0 ? near : valid;
}

function medianCenter(coords: Array<[number, number]>): [number, number] {
    const lngs = coords.map(([lng]) => lng).sort((a, b) => a - b);
    const lats = coords.map(([, lat]) => lat).sort((a, b) => a - b);
    const mid = Math.floor(coords.length / 2);

    return [lngs[mid], lats[mid]];
}
